// extracted by mini-css-extract-plugin
export default {"container":"ufU_EGaKpOXo9nVRu00T","avatarsContainer":"NjNo9KQNTHG4BNHVYVkM","pictureItem":"Gmw04VjzOIgxSVR2Y1G1","countRecruiters":"kb9u6Qk9maJrD5wSZkI8"};